export const useRoute = () => {
	const $page = usePage();

	const isActive = (url: string): boolean => {
		if (url === '#') {
			return false;
		}
		url = url.slice(url.indexOf('://') + 3);
		const index = url.indexOf('/');
		if (index === -1) {
			url = '/';
		}
		url = url.slice(index);
		return $page.url === url;
	};

	return {
		isActive,
	};
};
